import React from 'react';
import image from "../../assets/servicesimages/CP2.jpg";
import {
  FaCheckCircle,
  FaCogs,
  FaHandshake,
  FaClock,
  FaUsers,
  FaGavel,
  FaDraftingCompass,
  FaToolbox,
} from "react-icons/fa";
import './whychoose.css';

function Whychooseus() {
  const features = [
    { icon: <FaToolbox />, text: 'Proven Industry Expertise' },
    { icon: <FaCogs />, text: 'Comprehensive End-to-End Services' },
    { icon: <FaHandshake />, text: 'Transparent and Trustworthy Dealings' },
    { icon: <FaCheckCircle />, text: 'Uncompromised Quality Standards' },
    { icon: <FaClock />, text: 'Timely Project Delivery' },
    { icon: <FaUsers />, text: 'Customer-First Approach' },
    { icon: <FaGavel />, text: 'Complete Legal & Regulatory Support' },
    { icon: <FaDraftingCompass />, text: 'Modern, Future-Ready Designs' },
  ];

  return (
    <>
      <div className="section-title clearfix d-flex flex-column align-items-center">
        <div class="title-header">
          <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Why choose us</h5>
          {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
        </div>
        <div className='underline' style={{ width: "8%" }} ></div>
      </div>
      <div className="container whychooseus-wrapper">
        <div className="whychooseus-container">
          <div className="whychooseus-image-section">
            <img src={image} alt="Why Choose Us" className="whychooseus-image" />
          </div>
          <div className="whychooseus-content">
            {/* <h3 className="whychooseus-subheading">Why Choose Us</h3> */}
            <h1 className="whychooseus-heading">
              At New Sky Infra, we don’t just build structures — we build trust, value, and long-term relationships.
            </h1>
            <p className="whychooseus-description">
              Here's why we stand out in the world of construction and real estate:
            </p>

            <div className="whychooseus-features-grid">
              {features.map((feature, index) => (
                <div className="whychooseus-feature-item" key={index}>
                  <div className="whychooseus-icon">{feature.icon}</div>
                  <p className="whychooseus-feature-text">{feature.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Whychooseus;
